var _path, _path2, _rect, _rect2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _path5, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyDesicisionEngineResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 134C138.209 134 140 132.209 140 130L140 38C140 35.7909 138.209 34 136 34L36.7742 34L16 34C13.7909 34 12 35.7909 12 38V58L12 130C12 132.209 13.7909 134 16 134L136 134Z",
    fill: "#A5D5FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144 126C146.209 126 148 124.209 148 122L148 30C148 27.7909 146.209 26 144 26L44.7742 26L24 26C21.7909 26 20 27.7909 20 30V50L20 122C20 124.209 21.7909 126 24 126L144 126Z",
    fill: "#1E95F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 45,
    width: 32,
    height: 15,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 15,
    rx: 5,
    transform: "matrix(-1 0 0 1 98 95)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 70H75.8718L81 85H46.1282L41 70Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77.5L108.5 69L126 77.5L108.5 86L91 77.5Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 52.5,
    x2: 59,
    y2: 52.5,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 11,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 98 102)",
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 93,
    y1: 77.5,
    x2: 78,
    y2: 77.5,
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 59.5,
    y1: 70,
    x2: 59.5,
    y2: 52,
    stroke: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 108.5,
    y1: 103,
    x2: 108.5,
    y2: 85,
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144 26C146.209 26 148 27.7909 148 30L148 33L20 33L20 30C20 27.7909 21.7909 26 24 26L144 26Z",
    fill: "#A5D5FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 29.499,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.499,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 29.499,
    r: 1.5,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDesicisionEngineResults);
export default __webpack_public_path__ + "static/media/empty-desicision-engine-results.a2951703.svg";
export { ForwardRef as ReactComponent };